module.exports = __webpack_public_path__ + "img/iphone-map-NETHERLANDS-en.5d6a9e9a.png";